import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as fromServices from '../../services';
import { ModalService } from '../../services/modal.service';
import * as fromModals from '../modal';

@Component({
  selector: 'hdw-resource-content-items',
  templateUrl: './resource-content-items.component.html',
  styleUrls: ['./resource-content-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ResourceContentItemsComponent implements OnInit {
  constructor(
    private modalService: ModalService,
    private toolIdentifierService: fromServices.ToolIdentifierService
  ) {}
  public locatorToolNames = fromServices.LocatorTools;
  public showInfo: boolean;
  public locatorToolName: fromServices.LocatorTools = fromServices.LocatorTools.HealthCenter;
  public canShowResources: boolean = false;

  public ngOnInit(): void {
    this.locatorToolName = this.toolIdentifierService.getCurrentTool();
  }

  public noteToHrsaHealthCenters(): void {
    this.modalService.open(fromModals.ModalComponent, {
      title: 'Note to HRSA Health Centers',
      componentType: fromModals.NoteToHrsaComponent
    });
  }

  public aboutThisTool(): void {
    this.modalService.open(fromModals.ModalComponent, {
      title: 'About This Tool',
      componentType: fromModals.AboutThisToolComponent
    });
  }

  public aboutThisToolHiv(): void {
    this.modalService.open(fromModals.ModalComponent, {
      title: 'About Find a Ryan White HIV/AIDS Program Medical Provider',
      componentType: fromModals.AboutHivToolComponent
    });
  }

  public aboutOrganTransportCenters(): void {
    this.modalService.open(fromModals.ModalComponent, {
      title: 'About Organ Transplantation',
      componentType: fromModals.AboutOrganTransportComponent
    });
  }

  public aboutMigrantAndSeasonal(): void {
    this.modalService.open(fromModals.ModalComponent, {
      title: 'Find a Migrant and Seasonal Head Start (MSHS)',
      componentType: fromModals.AboutMigrantsSeasonalToolComponent
    });
  }

  public handleOpenInfo(): void {
    this.showInfo = !this.showInfo;
  }

  public handleCanShowResources(): void {
    this.canShowResources = !this.canShowResources;
  }
}
